namespace TabAurous.Retail {
    export interface ExchangeForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        PartyId: Serenity.IntegerEditor;
        CustomerName: Serenity.StringEditor;
        Address: Serenity.TextAreaEditor;
        Mobile: Serenity.IntegerEditor;
        PanNumber: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BirthDate: Serenity.DateEditor;
        Anniversary: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: ExchangeItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        RoundOff: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
    }

    export class ExchangeForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.Exchange';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExchangeForm.init)  {
                ExchangeForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.ServiceLookupEditor;
                var w6 = s.TextAreaEditor;
                var w7 = s.LookupEditor;
                var w8 = s.DecimalEditor;
                var w9 = s.ImageUploadEditor;
                var w10 = ExchangeItemsEditor;

                Q.initFormType(ExchangeForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'AutoPosting', w4,
                    'POSCustomerId', w5,
                    'PartyId', w3,
                    'CustomerName', w2,
                    'Address', w6,
                    'Mobile', w3,
                    'PanNumber', w2,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'BirthDate', w0,
                    'Anniversary', w0,
                    'CurrencyId', w7,
                    'ExchRate', w8,
                    'UserId', w7,
                    'EmployeeId', w3,
                    'ProductItemImage', w9,
                    'ItemDetails', w10,
                    'FinancialYearId', w3,
                    'Pieces', w3,
                    'Weight', w8,
                    'NetWeight', w8,
                    'NetAmount', w8,
                    'TaxAmount', w8,
                    'Discount', w8,
                    'AdditionalCharges', w8,
                    'RoundOff', w8,
                    'GrossAmount', w8,
                    'Remark', w6,
                    'ShipAddressId', w3,
                    'CompanyId', w3,
                    'ShipmentId', w3
                ]);
            }
        }
    }
}
